export const heading = 'Mulish, sans-serif';
export const body = 'Mulish, sans-serif';
